import { render } from "./PasserelleTaxiVtc.vue?vue&type=template&id=20565b28"
import script from "./PasserelleTaxiVtc.vue?vue&type=script&lang=js"
export * from "./PasserelleTaxiVtc.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__